export default __webpack_public_path__ + "static/media/finance_transparent.91e03efb.webp";